import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notify-tax-only',
  templateUrl: './notify-tax-only.component.html',
  styleUrls: ['./notify-tax-only.component.scss']
})
export class NotifyTaxOnlyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
